import React from "react";
import { useNavigate } from "react-router-dom";
import {
  FaFileAlt,
  FaGlobe,
  FaCertificate,
  FaUsers,
  FaBalanceScale,
  FaVideo,
  FaKeyboard,
  FaMicrophoneAlt,
  FaEdit,
  FaDesktop,
} from "react-icons/fa";
import "../styles/Services.css";

const serviceIcons = {
  1: <FaFileAlt />,
  2: <FaGlobe />,
  3: <FaCertificate />,
  4: <FaUsers />,
  5: <FaBalanceScale />,
  6: <FaVideo />,
  7: <FaKeyboard />,
  8: <FaMicrophoneAlt />,
  9: <FaEdit />,
  10: <FaDesktop />,
};

const services = [
  { id: 1, title: "Document Translation", description: "Professional translation of legal, medical, academic, and technical documents." },
  { id: 2, title: "Website & Software Localization", description: "Tailoring websites and applications for global audiences." },
  { id: 3, title: "Certified Translations", description: "Official translations for immigration or legal purposes." },
  { id: 4, title: "Simultaneous Interpreting", description: "Live interpreting for conferences and international meetings." },
  { id: 5, title: "Consecutive Interpreting", description: "Ideal for court, business, and medical consultations." },
  { id: 6, title: "Remote Interpreting", description: "Telephone and video interpreting for flexible communication." },
  { id: 7, title: "Transcription & Subtitling", description: "Accurate transcription and subtitles in multiple languages." },
  { id: 8, title: "Voice-over & Dubbing", description: "Professional audio production for films and media." },
  { id: 9, title: "Proofreading & Editing", description: "Ensuring translated content is polished and error-free." },
  { id: 10, title: "Multilingual DTP", description: "Design and desktop publishing in multiple languages." },
];

function ServiceList() {
  const navigate = useNavigate();

  const handleGetQuote = (service) => {
    navigate(`/services/${service.id}`, { state: { serviceId: service.id } });
  };

  return (
    <section className="services" id="services">
      <h2>Our Services</h2>
      <div className="service-grid">
        {services.map((service) => (
          <div key={service.id} className="service-card" onClick={() => handleGetQuote(service)}>
            <div className="service-icon">{serviceIcons[service.id]}</div>
            <h3>{service.title}</h3>
            <p>{service.description}</p>
            <button
              className="quote-btn"
              onClick={() => handleGetQuote(service)}
            >
              Get Quote
            </button>
          </div>
        ))}
      </div>
    </section>
  );
}

export default ServiceList;
